import React from 'react'

import { useAverageFormRepliesAmountByPeriod } from './_load/AverageFormRepliesAmountByPeriodLoader'
import BarChart from '../../../../../packages/kiti-charts/components/charts/BarChart'

const Chart = ({ widget }) => {
  const data = useAverageFormRepliesAmountByPeriod()

  const config = {
    data,
    autoFit: true,
    xField: 'percentage',
    yField: 'label',
    color: widget.data?.color
  }

  return <BarChart {...config} />
}

export default Chart
